type ConsentType = 'analytics' | 'targeted_advertising' | 'essential_services' | 'personalization'

export default defineNuxtPlugin(async () => {
  const { $sitewideConfig } = useNuxtApp()
  const { isIntegrationEnabled, disableIntegration } = useUtils()

  if (!isIntegrationEnabled('ketch')) return

  const ketchCode = $sitewideConfig.config.ketchCode

  /* eslint-disable */
  // prettier-ignore
  !function(){window.semaphore=window.semaphore||[],window.ketch=function(){window.semaphore.push(arguments)};var e=document.createElement("script");e.type="text/javascript",e.src="https://global.ketchcdn.com/web/v3/config/realtruck/" + ketchCode + "/boot.js",e.defer=e.async=!0,document.getElementsByTagName("head")[0].appendChild(e)}();
  /* eslint-enable */

  function getKetchConsent(): Promise<any> {
    return new Promise((resolve) => {
      window.ketch('on', 'consent', () => {
        resolve()
      })
    })
  }

  window.ketch('on', 'userConsentUpdated', () => {
    window.location.reload()
  })

  // window.ketchConsent is filled
  await getKetchConsent()

  function hasConsent(type: ConsentType) {
    return window.ketchConsent?.[type] || false
  }

  function showExperience() {
    window.ketch('showExperience')
  }

  function getConsent(): Record<ConsentType, boolean> {
    return {
      analytics: window.ketchConsent?.analytics || false,
      targeted_advertising: window.ketchConsent?.targeted_advertising || false,
      essential_services: window.ketchConsent?.essential_services || false,
      personalization: window.ketchConsent?.personalization || false,
    }
  }

  if (!hasConsent('analytics')) {
    disableIntegration('amplitude')
    disableIntegration('invoca')
  }

  if (!hasConsent('targeted_advertising')) disableIntegration('wisepops')

  return {
    provide: {
      ketch: {
        showExperience,
        hasConsent,
        getConsent,
      },
    },
  }
})
